import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";
// import { ReCaptcha } from 'react-recaptcha-v3'



const RecaptBox = ({fieldClass, captRef, /*handleonError, handleonExpire,*/ handleonVerify}) => (
    <div className="form-group recapta-group">
        <div className={fieldClass}>
            <ReCAPTCHA
                ref={captRef}
                size="invisible"
                sitekey={process.env.GATSBY_RECAPTCHA_KEY}
                onChange={handleonVerify}
            />

        </div>
    </div>
);

export default RecaptBox